import { render, staticRenderFns } from "./SistemaPermissaoIndex.vue?vue&type=template&id=ccaf2c34"
import script from "./SistemaPermissaoIndex.vue?vue&type=script&lang=js"
export * from "./SistemaPermissaoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports